<template>
  <div class="home">
    <!-- 顶部banner区域 -->
    <div id="home" class="banner-section">
      <div class="header">
        <div class="logo">
          <img class="logo-img" src="@/assets/img/logo.png" alt="logo" />
          <span class="logo-text">正企元</span>
        </div>
        <div class="nav">
          <div
            v-for="(item, index) in navItems"
            :key="index"
            class="nav-item"
            :class="{ active: activeNav === item.id }"
            @click="scrollToSection(item.id)"
          >{{ item.title }}</div>
        </div>
      </div>
    </div>

    <!-- 建筑图形区域 -->
    <div id="building" class="building-section">
      <img class="leftImage" src="@/assets/img/build.png" alt />
      <div class="RightDes">
        <div class="CompanyTop">
          <div class="CompanyName">公司简介</div>
          <div class="English">&nbsp;&nbsp;/&nbsp;&nbsp;WHO WE ARE</div>
        </div>
        <div class="article">
          <div
            class="article-title"
          >杭州正企元数字科技有限公司(简称“正企元数字科技”)成立于2025年，总部坐落于中国数字经济高地--杭州市上城区临丁路1190号-尚坤丁兰国际，是一家以人工智能、大数据、云计算为核心驱动力的创新型科技企业。公司致力于为政府、企业及行业伙伴提供数字化转型全栈解决方案，助力客户在智能数字时代实现数字创造价值。</div>
          <div
            class="article-title"
          >在数字化时代浪潮的前沿，正企元以科技为笔，智慧为墨，绘制出一幅前所未有的数据蓝图。我们不仅是守护者，更是开拓者，致力于将数字科技、信息、确权、资产、处理、流通、共享、交易、价值与安全融为一体，打造数据资产服务领域的璀璨星辰。</div>
        </div>
      </div>
    </div>

    <!-- 服务流程区域 -->
    <div id="service" class="service-section">
      <div class="section-title">
        核心技术
        <span class="eng">core technology</span>
        <div class="lineTitle"></div>
      </div>
      <div class="service-steps">
        <div class="step">
          <div class="step-icon">
            <span class="worksName">确权社交</span>
            <span class="worksDesc">数字确权社交技术</span>
          </div>
          <div class="step-name">确权社交</div>
          <div class="step-dot">
            <img class="default-img" src="@/assets/img/logo/lianjie.png" alt />
            <img class="hover-img" src="@/assets/img/logo/lianjie2.png" alt />
          </div>
        </div>
        <div class="step">
          <div class="step-icon">
            <span class="worksName">还价电商</span>
            <span class="worksDesc">确权还价电商管理技术</span>
          </div>
          <div class="step-name">还价电商</div>
          <div class="step-dot">
            <img class="default-img" src="@/assets/img/logo/dianshang.png" alt />
            <img class="hover-img" src="@/assets/img/logo/dianshang2.png" alt />
          </div>
        </div>
        <div class="step">
          <div class="step-icon">
            <span class="worksName">品牌管理</span>
            <span class="worksDesc">智能化品牌提升技术</span>
          </div>
          <div class="step-name">品牌管理</div>
          <div class="step-dot">
            <img class="default-img" src="@/assets/img/logo/pinpai.png" alt />
            <img class="hover-img" src="@/assets/img/logo/pinpai2.png" alt />
          </div>
        </div>
        <div class="step">
          <div class="step-icon">
            <span class="worksName">智慧营销</span>
            <span class="worksDesc">智慧增量广告营销技术</span>
          </div>
          <div class="step-name">智慧营销</div>
          <div class="step-dot">
            <img class="default-img" src="@/assets/img/logo/yingxiao.png" alt />
            <img class="hover-img" src="@/assets/img/logo/yingxiao2.png" alt />
          </div>
        </div>
        <div class="step">
          <div class="step-icon">
            <span class="worksName">执行管理</span>
            <span class="worksDesc">智慧增量广告营销技术</span>
          </div>
          <div class="step-name">执行管理</div>
          <div class="step-dot">
            <img class="default-img" src="@/assets/img/logo/zhixing.png" alt />
            <img class="hover-img" src="@/assets/img/logo/zhixing2.png" alt />
          </div>
        </div>
      </div>
    </div>

    <!-- 产品展示区域 -->
    <div id="product" class="product-section">
      <div class="section-title">
        产品服务
        <span class="eng" style="color: #666666">Product Services</span>
        <div class="lineTitle" style="background: #9599ff; border-radius: 2px"></div>
      </div>
      <div class="product-grid">
        <div class="product-item">
          <div class="product-icon">
            <div class="icon-default">
              <span class="title">平台服务</span>
            </div>
            <div class="icon-hover">
              <span class="desc">
                <span class="descTitle">平台服务</span>
                <span>1、数字确权服务</span>
                <span>2、确权社交服务</span>
                <span>3、还价电商服务</span>
                <span>4、品牌营销服务</span>
                <span class="descTitle2">MORE →</span>
              </span>
            </div>
          </div>
        </div>
        <div class="product-item">
          <div class="product-icon">
            <div class="icon-default">
              <span class="title">软件服务</span>
            </div>
            <div class="icon-hover">
              <span class="desc">
                <span class="descTitle">软件服务</span>
                <span>1、生产管理系统</span>
                <span>2、私域电商系统</span>
                <span>3、确权收银系统</span>
                <span>4、仓库管理系统</span>
                <span class="descTitle2">MORE →</span>
              </span>
            </div>
          </div>
        </div>
        <div class="product-item">
          <div class="product-icon">
            <div class="icon-default">
              <span class="title">数据服务</span>
            </div>
            <div class="icon-hover">
              <span class="desc">
                <span class="descTitle">数据服务</span>
                <span>1、数字确权服务</span>
                <span>2、数据储存服务</span>
                <span>3、数据共享服务</span>
                <span>4、数据增值服务</span>
                <span class="descTitle2">MORE →</span>
              </span>
            </div>
          </div>
        </div>
        <div class="product-item">
          <div class="product-icon">
            <div class="icon-default">
              <span class="title">品牌服务</span>
            </div>
            <div class="icon-hover">
              <span class="desc">
                <span class="descTitle">品牌服务</span>
                <span>1、增量广告服务</span>
                <span>2、知识产权服务</span>
                <span>3、品牌策划服务</span>
                <span>4、品牌增量服务</span>
                <span class="descTitle2">MORE →</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- //服务流程区域 -->
    <div id="liucheng" class="liucheng">
      <div
        class="section-title"
        style="font-size: 30px; text-align: left;margin-right: 850px;margin-bottom: 60px;"
      >服务流程</div>
      <img class="img-liucheng" src="@/assets/img/liucheng.png" alt />
    </div>

    <!-- 扫码下载 -->
    <div id="code" class="code">
      <div class="section-title" style="color: #fff; margin-top: 40px">
        扫码下载app
        <span class="eng">ZENBAY</span>
        <div class="lineTitle"></div>
      </div>
      <div class="code-box">
        <div class="code-box2">
          <img class="img-liucheng2" src="@/assets/img/appCode2.png" alt />
        </div>
      </div>
    </div>
    <!-- 地图位置 -->
    <div id="map" class="downMpa">
      <div class="section-title">
        联系我们
        <span class="eng" style="color: #666666">Contact Us</span>
        <div class="lineTitle" style="background: #9599ff; border-radius: 2px"></div>
      </div>
      <!-- <Map style="margin-top: 10px" /> -->
      <div class="tellUs">
        <div class="left">
          <div class="mapTitle">有需要联系我们</div>
          <div class="mapDesc">有任何问题，联系我们或者留下信息，我们将拜访你</div>
          <div class="maptel">联系电话：17513724567</div>
          <div class="mapEmail">邮 箱：zhengqiyuan268@126.com</div>
        </div>
        <div class="left2">
          <div class="mapTitle">我们如何联系您</div>
          <div class="info">
            <input class="input" v-model="input" placeholder="我们要如何称呼您" />
            <input class="input" v-model="input2" placeholder="公司名称" />
            <input class="input" v-model="input3" placeholder="联系方式" />
            <input class="input" v-model="input4" placeholder="合作方向，意见建议，备注等" />
          </div>
          <div class="btn">发送</div>
        </div>
      </div>
    </div>
    <!-- 底部区域 -->
    <div class="footer">
      <div class="footer-content">
        <div class="footer-column">
          <div class="footer-title">产品核心</div>
          <div class="footer-item">核心技术</div>
          <div class="footer-item">核心业务</div>
        </div>
        <div class="footer-column">
          <div class="footer-title">管理系统</div>
          <div class="footer-item">数字确权社交系统</div>
          <div class="footer-item">私域电商管理系统</div>
          <div class="footer-item">品牌管理服务系统</div>
          <div class="footer-item">智慧营销增量系统</div>
          <div class="footer-item">生产执行管理系统</div>
        </div>
        <div class="footer-column">
          <div class="footer-title">关于我们</div>
          <div class="footer-item">公司简介</div>
          <div class="footer-item">联系信息</div>
        </div>
        <div class="footer-column">
          <div class="footer-title">产品入口</div>
          <div class="footer-item">正贝元APP</div>
        </div>
        <div class="footer-qrcode">
          <div class="footer-title">关注我们</div>
          <img class="imgErWei" src="../assets/img/gongzhongcode.jpg" alt="二维码" />
        </div>
      </div>
      <div class="beian">Copyright © 2025 杭州正企元数字科技有限公司 ｜ <a href="https://beian.miit.gov.cn/" target="_blank">浙ICP备2025181804号-1</a> ｜ <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010202005094" target="_blank">浙公网安备33010202005094号</a></div>
    </div>
  </div>
</template>

<script>
import Map from "@/components/map.vue"
export default {
  name: "HomeView",
  components: {
    Map,
  },
  data() {
    return {
      input: "",
      input2: "",
      input3: "",
      input4: "",
      navItems: [
        {
          id: "home",
          title: "首页",
        },
        {
          id: "building",
          title: "公司简介",
        },
        {
          id: "service",
          title: "产品服务",
        },
        {
          id: "code",
          title: "app下载",
        },
        {
          id: "map",
          title: "联系我们",
        },
      ],
      activeNav: "home",
    }
  },
  methods: {
    //监听核心技术的显示
    toggleCore() {
      document.querySelectorAll(".step-dot").forEach((dot) => {
        dot.addEventListener("mouseenter", () => {
          dot
            .closest(".step")
            .querySelector(".step-icon")
            .classList.add("active")
        })
        dot.addEventListener("mouseleave", () => {
          dot
            .closest(".step")
            .querySelector(".step-icon")
            .classList.remove("active")
        })
      })
    },
    //tabber滚动

    scrollToSection(id) {
      this.activeNav = id
      const element = document.getElementById(id)
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        })
      }
    },

    // 处理产品项悬停效果
    handleProductHover(event, isEnter) {
      const productItem = event.currentTarget
      const productItems = document.querySelectorAll(".product-item")
      const index = Array.from(productItems).indexOf(productItem)

      // 获取产品项的宽度和当前边距
      const itemWidth = 208 // 产品项原始宽度
      const expandedWidth = 416 // 悬浮时的宽度（原宽度的2倍）
      const currentMargin = 50 // 当前的边距
      const desiredGap = 50 // 期望的间隙

      if (isEnter) {
        // 鼠标进入时
        // 如果不是第一个项目，移除第一个项目的expanded类
        if (index !== 0 && productItems.length > 0) {
          productItems[0].classList.remove('expanded')
        }

        // 计算悬浮项需要向左移动的距离，以保持视觉中心不变
        const hoverItemLeftShift = (expandedWidth - itemWidth) / 5

        // 设置悬浮项的变换
        productItem.style.transform = `translateX(-${hoverItemLeftShift}px)`
        console.log(hoverItemLeftShift, "向左移动的距离")

        // 处理其他项的位置
        productItems.forEach((item, i) => {
          if (i < index) {
            // 当前项之前的项向左移动
            // 简化计算：每个项向左移动固定距离
            const leftShift = (index - i) * 80 // 减小移动距离，避免超出屏幕
            console.log(leftShift, 1)

            item.style.transform = `translateX(-${leftShift}px)`
          } else if (i > index) {
            // 当前项之后的项向右移动
            // 简化计算：第一个右侧项移动固定距离，后续项递增
            const rightShift = i - index // 减小移动距离，避免超出屏幕
            console.log(rightShift, 2)

            item.style.transform = `translateX(${rightShift}px)`
          }
        })
      } else {
        // 鼠标离开时，所有项恢复原位
        productItems.forEach((item) => {
          item.style.transform = ""
        })

        // 如果没有其他项目处于悬停状态，恢复第一个项目的展开状态
        const isAnyItemHovered = Array.from(productItems).some((item, idx) =>
          idx !== 0 && item.matches(':hover')
        )

        if (!isAnyItemHovered && productItems.length > 0) {
          // 重新应用第一个项目的展开效果
          const firstItem = productItems[0]
          firstItem.classList.add('expanded')

          const hoverItemLeftShift = (expandedWidth - itemWidth) / 5
          firstItem.style.transform = `translateX(-${hoverItemLeftShift}px)`

          // 调整其他项目的位置
          productItems.forEach((item, i) => {
            if (i > 0) { // 只处理第一个之后的项目
              const rightShift = i // 第一个项目的索引是0
              item.style.transform = `translateX(${rightShift}px)`
            }
          })
        }
      }
    },
  },

  mounted() {
    this.toggleCore()
    // 在组件挂载后，为所有产品项添加鼠标悬停事件监听器
    this.$nextTick(() => {
      const productItems = document.querySelectorAll(".product-item")
      productItems.forEach((item) => {
        item.addEventListener("mouseenter", (e) =>
          this.handleProductHover(e, true)
        )
        item.addEventListener("mouseleave", (e) =>
          this.handleProductHover(e, false)
        )
      })

      // 默认展开第一个product-item
      if (productItems.length > 0) {
        const firstItem = productItems[0]
        firstItem.classList.add('expanded')

        // 计算第一个项目需要向左移动的距离
        const itemWidth = 208 // 产品项原始宽度
        const expandedWidth = 416 // 悬浮时的宽度（原宽度的2倍）
        const hoverItemLeftShift = (expandedWidth - itemWidth) / 5

        // 设置第一个项目的变换
        firstItem.style.transform = `translateX(-${hoverItemLeftShift}px)`

        // 调整其他项目的位置
        productItems.forEach((item, i) => {
          if (i > 0) { // 只处理第一个之后的项目
            const rightShift = i // 第一个项目的索引是0
            item.style.transform = `translateX(${rightShift}px)`
          }
        })
      }
    })
  },
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  color: #333;
  font-family: 'Source Han Sans CN', sans-serif;
}

/* 顶部banner区域 */
.banner-section {
  width: 100%;
  height: 1080px;
  background: linear-gradient(135deg, #1a237e, #4a148c) no-repeat;
  background-image: url('@/assets/img/banner.png');
  background-size: 100% 100%;
  background-position: center;
  // background-attachment: fixed;
  background-blend-mode: multiply;
  position: relative;
  overflow: hidden;
}

.header {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 20px 40px;
}

.logo {
  display: flex;
  align-items: center;
}

.logo-img {
  width: 60px;
  height: 60px;
  margin-right: 20px;
}

.logo-text {
  font-size: 24px;
  color: #fff;
  font-weight: bold;
}

.nav {
  display: flex;
  gap: 80px;
}

.nav-item {
  color: #fff;
  font-size: 24px;
  cursor: pointer;
  position: relative;
  padding: 5px 0;
}

.nav-item.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: #7377c6;
  color: #7377c6;
}

.banner-content {
  display: flex;
  justify-content: space-between;
  padding: 60px 80px;
}

.slogan {
  color: #fff;
}

.slogan-main {
  font-size: 48px;
  font-weight: bold;
  margin-bottom: 10px;
}

.slogan-sub {
  font-size: 48px;
  font-weight: bold;
  margin-bottom: 20px;
}

.slogan-en {
  font-size: 18px;
  opacity: 0.8;
  letter-spacing: 1px;
}

.globe-visual {
  width: 300px;
  height: 300px;
  position: relative;
}

.globe-circle {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.3) 0%,
    rgba(70, 130, 255, 0.8) 100%
  );
  position: relative;
  overflow: hidden;
  box-shadow: 0 0 30px rgba(0, 100, 255, 0.6);
}

/* 建筑图形区域 */
.building-section {
  height: 800px;
  background-color: #fff;
  display: flex;
  justify-content: center;

  align-items: center;

  .leftImage {
    max-width: 460px;
    height: auto;
  }

  .RightDes {
    width: 360px;
    height: auto;
    // border: 1px solid red;
    margin-left: 155px;

    .CompanyTop {
      display: flex;
      align-items: center;

      .CompanyName {
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 1.8vw;
        color: #030303;
        line-height: 40px;
      }

      .English {
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 1vw;
        color: #666666;
      }
    }

    .article {
      display: flex;
      flex-direction: column;
      margin-top: 15px;

      .article-title {
        width: 531px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 1vw;
        color: #666666;
        line-height: 35px;
      }
    }
  }
}

.building-visual {
  width: 80%;
  height: 150px;
  background-color: #e0e0e0;
  clip-path: polygon(
    0 100%,
    10% 80%,
    20% 90%,
    30% 70%,
    40% 85%,
    50% 60%,
    60% 75%,
    70% 55%,
    80% 70%,
    90% 50%,
    100% 70%,
    100% 100%
  );
}

/* 服务流程区域 */
.service-section {
  height: 522px;
  padding: 40px 0;
  background-color: #6c5ce7;
  background: url('../assets/img/back.png') no-repeat;
  background-size: 100% 100%;

  color: #fff;
}

.section-title {
  font-size: 28px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .eng {
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 18px;
    color: #f6f6f6;
  }

  .lineTitle {
    width: 60px;
    height: 4px;
    background: #ffffff;
    border-radius: 2px;
    margin-top: 8px;
  }
}

.service-steps {
  display: flex;
  justify-content: center;
  gap: 20px;
  padding: 0 40px;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.step-icon {
  width: 190px;
  height: 196px;
  border-radius: 10px;
  margin-bottom: 15px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  background: url('@/assets/img/bg.png') no-repeat;
  background-size: cover;
  // border: 1px solid red;

  .worksName {
    font-family: Source Han Sans CN;
    font-weight: bold;
    font-size: 1.02vw;
    color: #6652fc;
  }

  .worksDesc {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 0.8vw;
    color: #666666;
  }
}

.step-icon:hover {
  background: url('@/assets/img/bg2.png') no-repeat;
  background-size: cover;

  .worksName {
    font-family: Source Han Sans CN;
    font-weight: bold;
    font-size: 1.02vw;
    color: #fff;
  }

  .worksDesc {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 0.8vw;
    color: #fff;
  }
}

.step-name {
  font-size: 14px;
  text-align: center;
}

.step-dot {
  width: 58px;
  height: 58px;
  background-color: #fff;
  border-radius: 50%;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  // border: 1px solid red;
}

.step-dot .default-img {
  display: block;
}

.step-dot .hover-img {
  display: none;
}

.step-dot:hover .default-img,
.step-icon:hover ~ .step-dot .default-img {
  display: none;
}

.step-dot:hover .hover-img,
.step-icon:hover ~ .step-dot .hover-img {
  display: block;
  background: #f39840;
  width: 58px;
  height: 58px;
  border-radius: 50%;
}

.step-icon.active {
  background: url('@/assets/img/bg2.png') no-repeat;
  background-size: cover;
  // transform: scale(1.1);
  transition: all 0.3s ease;
}

/* 产品展示区域 */
.product-section {
  height: 1000px;
  padding: 50px 0;
  background-color: #f0f4f8;
}

.product-grid {
  display: flex;
  justify-content: center;
  position: relative;
  perspective: 1000px;
  padding: 20px 0;
  overflow: visible;
}

.product-item {
  width: 208px;
  height: 800px;
  // border: 1px solid red;
  padding: 10px;
  // background-color: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all 0.6s cubic-bezier(0.22, 1, 0.36, 1);
  margin-left: 50px;
  transform-origin: left center;
  position: relative;
  overflow: hidden;
  // box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.product-item:hover,
.product-item.expanded {
  width: 416px;
  /* 原宽度的2倍 */
  z-index: 10;
  // box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  /* 移除transform属性，由JavaScript控制位置 */
}

/* 当有产品项悬停时的全局状态 */
.product-grid .product-item {
  /* 所有产品项都有一个基础变换 */
  transition: all 0.6s cubic-bezier(0.22, 1, 0.36, 1);
}

/* 移除:has()选择器的位置变换样式，由JavaScript控制 */

/* 为所有产品项添加不同的过渡延迟，创造波浪效果 */
.product-item:nth-child(1) {
  transition-delay: 0s;
}

.product-item:nth-child(2) {
  transition-delay: 0.05s;
}

.product-item:nth-child(3) {
  transition-delay: 0.1s;
}

.product-item:nth-child(4) {
  transition-delay: 0.15s;
}

.product-item:nth-child(5) {
  transition-delay: 0.2s;
}

.product-item:first-child {
  // background-color: #6c5ce7;
  color: black;
}

.product-item:first-child .product-desc,
.product-item:first-child .more-link {
  color: rgba(255, 255, 255, 0.8);
}

.product-icon {
  width: 208px;
  height: 700px;
  position: relative;
}

.icon-default,
.icon-hover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  transition: opacity 0.3s ease;
  border: 1px solid #fff;
}

.icon-default {
  opacity: 1;

  .title {
    position: absolute;
    top: 550px;
    left: 55px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 24px;
    color: #5855fc;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
}

.icon-hover {
  width: 456px;
  height: 740px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: all 0.3s ease;

  .desc {
    width: 250px;
    position: absolute;
    // border: 1px solid red;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 22px;
    color: #ffffff;
    bottom: 60px;
    left: 50px;
    display: flex;
    flex-direction: column;

    .descTitle {
      font-family: Source Han Sans CN;
      font-weight: 500;
      font-size: 30px;
      color: #ffffff;
      margin-bottom: 10px;
    }
    .descTitle2 {
      font-family: Source Han Sans CN;
      font-weight: 500;
      font-size: 26px;
      color: #ffffff;
      margin-top: 20px;
    }
  }
}

.product-item:hover .icon-default,
.product-item.expanded .icon-default {
  opacity: 0;
}

.product-item:hover .icon-hover,
.product-item.expanded .icon-hover {
  opacity: 1;
}

/* 为每个产品设置不同的默认和悬浮图片 */
.product-item:nth-child(1) .icon-default {
  background-image: url('@/assets/img/product/first.png');
}

.product-item:nth-child(1) .icon-hover {
  background-image: url('@/assets/img/product/one.png');
}

.product-item:nth-child(2) .icon-default {
  background-image: url('@/assets/img/product/second.png');
}

.product-item:nth-child(2) .icon-hover {
  background-image: url('@/assets/img/product/three.png');
}

.product-item:nth-child(3) .icon-default {
  background-image: url('@/assets/img/product/third.png');
}

.product-item:nth-child(3) .icon-hover {
  background-image: url('@/assets/img/product/four.png');
}

.product-item:nth-child(4) .icon-default {
  background-image: url('@/assets/img/product/fourth.png');
}

.product-item:nth-child(4) .icon-hover {
  background-image: url('@/assets/img/product/two.png');
}

.product-info {
  text-align: center;
  width: 100%;
}

.product-name {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

.product-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  margin-bottom: 15px;
}

.more-link {
  font-size: 14px;
  color: #6c5ce7;
  font-weight: bold;
  cursor: pointer;
  margin-top: 10px;
}

// 服务流程
.liucheng {
  width: 100%;
  height: 500px;
  //  border: 1px solid red;
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 50px;

  .img-liucheng {
    max-width: 1000px;
    height: auto;
  }
}

/* 扫码下载 */
.code {
  width: 100%;
  height: 680px;
  // border: 1px solid red;
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: url('@/assets/img/code.png') no-repeat;
  background-size: 100% 100%;

  .code-box {
    width: 410px;
    height: 410px;
    background: rgba(246, 246, 246, 0.4);
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;

    .code-box2 {
      width: 380px;
      height: 380px;
      background: rgba(246, 246, 246, 0.2);
      border-radius: 20px;
      display: flex;
      justify-content: center;
      align-items: center;

      .img-liucheng2 {
        max-width: 339px;
        height: auto;
        border-radius: 20px;
      }
    }
  }
}

.downMpa {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 50px;

  .tellUs {
    width: 1200px;
    height: 620px;
    // border: 1px solid red;
    margin-left: auto;
    margin-right: auto;
    padding: 20px;
    display: flex;
    background: #ffffff;
    box-shadow: 0px 0px 90px 0px rgba(34, 33, 34, 0.07);
    border-radius: 10px;
    margin-top: 50px;

    .left {
      width: 50%;
      height: 100%;
      border-right: 1px dashed #ccc;
      display: flex;
      flex-direction: column;
      // justify-content: space-evenly;
      align-items: center;

      .mapTitle {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 28px;
        color: #333333;
        margin-top: 60px;
      }

      .btn {
        width: 180px;
        height: 50px;
        background: #6652fc;
        box-shadow: 0px 0px 35px 0px rgba(12, 0, 97, 0.4);
        border-radius: 35px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 24px;
        color: #ffffff;
        text-align: center;
        line-height: 50px;
      }

      .mapDesc {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 18px;
        color: #666666;
        margin-top: 40px;
      }

      .maptel {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 18px;
        color: #666666;
        margin-top: 100px;
      }

      .mapEmail {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 18px;
        color: #666666;
        margin-top: 30px;
      }

      .input {
        margin-left: 60px;
        margin-top: 2px;
        border-top: none;
        border-bottom: 1px solid rgba(153, 153, 153, 0.5);
        border-left: none;
        border-right: none;
        height: 60px;
        width: 420px;
        outline: none;
        font-size: 18px;
        background: none;
        padding: 0 10px;
      }
    }

    .left2 {
      width: 50%;
      height: 100%;
      // border-right: 1px dashed #ccc;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: center;

      .mapTitle {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 28px;
        color: #333333;
      }

      .btn {
        width: 180px;
        height: 50px;
        background: #6652fc;
        box-shadow: 0px 0px 35px 0px rgba(12, 0, 97, 0.4);
        border-radius: 35px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 24px;
        color: #ffffff;
        text-align: center;
        line-height: 50px;
      }

      .mapDesc {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 18px;
        color: #666666;
      }

      .maptel {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 18px;
        color: #666666;
      }

      .mapEmail {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 18px;
        color: #666666;
      }

      .input {
        margin-left: 60px;
        margin-top: 2px;
        border-top: none;
        border-bottom: 1px solid rgba(153, 153, 153, 0.5);
        border-left: none;
        border-right: none;
        height: 60px;
        width: 420px;
        outline: none;
        font-size: 18px;
        background: none;
        padding: 0 10px;
      }
    }
  }
}

/* 底部区域 */
.footer {
  background-color: #1a1a2e;
  color: #fff;
  padding: 50px 0;
  box-sizing: border-box;
  margin-top: 80px;
}

.footer-content {
  display: flex;
  justify-content: space-evenly;
  padding: 0 60px;
}

.beian {
  margin-left: 700px;
  margin-top: 40px;
}

.beian a {
  color: #ffffff;
  text-decoration: none;
}

.beian a:hover {
  color: #00ff00;
}

.footer-column {
  display: flex;
  flex-direction: column;
}

.footer-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
}

.footer-item {
  font-size: 14px;
  color: #aaa;
  margin-bottom: 10px;
  cursor: pointer;
}

.footer-item:hover {
  color: #fff;
}

.footer-qrcode {
  width: 100px;
  height: 100px;

  // background-color: #fff;
  .imgErWei {
    width: 82px;
    height: 81px;
  }
}

/* 响应式调整 */
@media screen and (max-width: 768px) {
  .header {
    padding: 15px 20px;
  }

  .logo-img {
    width: 30px;
    height: 30px;
  }

  .logo-text {
    font-size: 18px;
  }

  .nav {
    gap: 15px;
  }

  .nav-item {
    font-size: 14px;
  }

  .banner-content {
    flex-direction: column;
    padding: 30px 20px;
  }

  .slogan-main,
  .slogan-sub {
    font-size: 32px;
  }

  .globe-visual {
    width: 200px;
    height: 200px;
    margin: 30px auto 0;
  }

  .service-steps {
    flex-wrap: wrap;
    gap: 30px;
  }

  .product-row {
    flex-wrap: wrap;
  }

  .product-item {
    min-width: 45%;
    margin-bottom: 15px;
  }

  .solution-grid {
    flex-wrap: wrap;
  }

  .solution-item {
    width: 45%;
    margin-bottom: 15px;
  }

  .footer-content {
    flex-wrap: wrap;
  }

  .footer-column {
    width: 50%;
    margin-bottom: 30px;
  }
}
</style>
.info {
width: 100%;

/deep/ .el-input {
width: 100%;
height: 36px;
margin-bottom: 15px;

.el-input__inner {
height: 100%;
padding: 0 12px;
font-size: 14px;
border-radius: 4px;
transition: all 0.3s;

&:focus {
border-color: #6c5ce7;
}
}
}